import React from 'react'
import { Box, Typography } from '@mui/material'
import { LinkedIn } from '@mui/icons-material'

const LinkedInTab = () => (
  <Box
    sx={{
      textAlign: 'center',
      py: 10,
      px: 3,
      border: '2px dashed #e2e8f0',
      borderRadius: 3,
      bgcolor: '#f8fafc',
    }}
  >
    <LinkedIn sx={{ fontSize: 72, color: '#0a66c2', mb: 2, opacity: 0.5 }} />
    <Typography variant='h6' sx={{ color: '#475569', fontWeight: 600, mb: 1 }}>
      No posts found
    </Typography>
    <Typography variant='body2' color='text.secondary'>
      LinkedIn posts and updates will appear here
    </Typography>
  </Box>
)

export default LinkedInTab
